import { c as _c } from "react/compiler-runtime";
import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './InputLayout.module.css';
export type InputLayoutProps = Omit<ComponentProps<'label'>, 'children'> & {
  label: string;
  children: (options: InputLayoutRenderOptions) => React.JSX.Element;
  /**
   * Only a min height for the content will be set instead of a fixed height.
   * This allows the content to be bigger than 40 px and spread over multiple lines
   */
  multiline?: boolean;
};
export const InputLayout: FunctionComponent<InputLayoutProps> = React.memo(props => {
  const $ = _c(16);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== props) {
    const {
      label,
      children,
      className,
      multiline,
      ...remainingProps
    } = prepareProps({
      props
    });
    t2 = remainingProps;
    t3 = classes(className, styles.label);
    t4 = label ? <div className={styles.labelText}>{label}</div> : undefined;
    const t5 = multiline ? styles.inputWrapperMultiline : null;
    if ($[6] !== t5) {
      t0 = classes(styles.inputWrapper, t5);
      $[6] = t5;
      $[7] = t0;
    } else {
      t0 = $[7];
    }
    t1 = children({});
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1) {
    t5 = <div className={t0}>{t1}</div>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <label {...t2} className={t3}>{t4}{t5}</label>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
});
export type InputLayoutRenderOptions = Record<never, never>;